import { useEffect, useState } from "react";
import { Card, Col, Row, Button, Tree } from "antd";

import { recordError } from "src/utils/logService";
import { Messages, Notify } from '../../../services/custom/Messages';
import { openNotification } from '@seims/shared';
import util from '../../../utils/functions/custom';
import EditTargetBeneficiaries from "./EditTargetBeneficiaries";
import service from '../../../services/citizenscienceService';

const TargetBeneficiaries = ({ data }) => {

  const [projectBeneficiaries, setProjectBeneficiaries] = useState([]);
  let msg = "";
  const [showModal, setShowModal] = useState(false);


  useEffect(() => {
    loadProjectBeneficiaries();
  }, []);

  const loadProjectBeneficiaries = () => {
    if (!util.isEmpty(data)) {
      const d = transformData(data.beneficiaries);
      setProjectBeneficiaries(d);
    }
  }

  const transformData = (data) => {
    return data.map((item) => ({
      key: item.key,
      title: item.value,
      parentKey: item.key,
      children: item.impact
        ? transformData(item.impact, { parentKey: item.key })
        : [],
    }));
  };

  const editProjectBeneficiaries = () => {
    setShowModal(true);
  }

  const handleCancel = () => {
    setShowModal(false);
  };


  const handleModalSubmit = async (values, returnData, other) => {
    try {

      console.log("BEFORE BE", values, other);

      data.projectProfile.beneficiaries = values;
      let project = data.projectProfile;
      let projectId = data.id;
      // if (other !== undefined) data.projectProfile.otherBeneficiary = other;
      setProjectBeneficiaries(returnData);
      const request = await service.editProject(
          project,
          projectId
        );

        if (request?.status == 200 || request?.status == 201) {
          msg = util.parseMessage(Messages.ADD_SUCCESS, "Target beneficiaries");
          openNotification("Target Beneficiaries", msg, Notify.SUCCESS);
         }
      setShowModal(false);

    } catch (error) {
      msg = util.parseMessage(Messages.GET_FAILURE);
      openNotification("Participant", msg, Notify.ERROR);
      recordError(error);
    };
  };



  return (
    <div className=''>
      <Col xs={24}>
        <div className="public-portal-section">
          <h2> Citizen Science - {data.projectProfile.name}</h2>
        </div>
      </Col>
      <Col xs={24}>
        <h3 className="center-align">Project Status - <span style={{ color: data.statusColor }}>{data.status}</span> </h3>
      </Col>
      <Card
        bordered={false}
        headStyle={{ border: 0, textAlign: "center" }}
        key="target-beneficiary-card"
      >
        <Row key="edit-target-beneficiaries">
          <Col xs={12}><h3 className="h3-text">Target Beneficiaries</h3></Col>
          {(data.status !== "Rejected" && data.status !== "Closed") && (
            <Col xs={12}>
              <Button className="right-align-button edit-button" type="primary" shape="round" onClick={() => editProjectBeneficiaries()}  >
                Edit
              </Button>
            </Col>
          )}
        </Row>

        <div className="space"></div>
        <Tree
          treeData={projectBeneficiaries}
          defaultExpandAll={true}
        />
        {/* {data.projectProfile.otherBeneficiary !== undefined && (
          <Row>
            <Col xs={6} md={6}>Other beneficiary:</Col>
            <Col xs={18} md={18}>{data.projectProfile.otherBeneficiary}</Col>
          </Row>
        )} */}
      </Card>
      <Row key="beneficiary-row">
        <Col xs={24}>
          <EditTargetBeneficiaries
            beneficiaryData={data}
            visible={showModal}
            onCancel={handleCancel}
            onModalSubmit={handleModalSubmit}
          />
        </Col>
      </Row>
    </div>
  );
};

export default TargetBeneficiaries;
